module.exports = __webpack_public_path__ + "img/card-multidays.9bb1de4f.svg";